import * as React from "react"
import type { SVGProps } from "react"
const SvgReceiptSlip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M21 5.43a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v15.8q0 .35.3.47.3.13.55-.12l.3-.3a.5.5 0 0 1 .7 0l.8.8a.5.5 0 0 0 .7 0l.8-.8a.5.5 0 0 1 .7 0l.8.8a.5.5 0 0 0 .7 0l.8-.8a.5.5 0 0 1 .7 0l.8.8a.5.5 0 0 0 .7 0l.8-.8a.5.5 0 0 1 .7 0l.8.8a.5.5 0 0 0 .7 0l.8-.8a.5.5 0 0 1 .7 0l.8.8a.5.5 0 0 0 .7 0l.8-.8a.5.5 0 0 1 .7 0l.3.3q.25.25.55.12.3-.12.3-.47zm-2 14.1H5V5.43h14z"
    />
    <path d="M7 17.43h10q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H7a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29" />
    <path
      fillRule="evenodd"
      d="M7 13.43h10q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H7a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29m0-4h10q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H7a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29"
    />
  </svg>
)
export default SvgReceiptSlip
